import stl from "./MakeCars.module.css";
import { Link } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import {useTranslation} from "@i18n";

const MakeCars = ({ makes, cityName }) => {
  const { t } = useTranslation();
  const { createUrl } = useHelpers();
  return (
    <>
      <div className={stl.MCC_container}>
        <h2>
          {t("سيارات للبيع في {{cityName}} حسب الماركة", {
            ns: "web_city",
            cityName: cityName,
          })}
        </h2>
        <div className={stl.MCC_makesContainer}>
          {makes.map((make, idx) => {
            return (
              <Link
                key={idx}
                className={`${stl.anchorDesign} ${idx == 8 && "m-show"}`}
                to={createUrl(`/autos/${make.name_seo}`)}
              >
                <div className={stl.imgContainer}>
                  <img
                    src={make.icon}
                    alt={make.name}
                    width={90}
                    height={90}
                    loading="lazy"
                  />
                </div>
                <p>{make.name}</p>
              </Link>
            );
          })}
        </div>
        <div className={stl.buttonContainer}>
          <Link
            to={createUrl(`/autos`)}
            className={["whtBtn", stl.button].join(" ")}
          >
            {t("شاهد جميع الماركات", {
              ns: "web_city",
            })}
          </Link>
        </div>
      </div>
    </>
  );
};

export default MakeCars;
